import Model from "braindamage/model";
import BirlExerciseEntrySchema from 'generated/schemas/birl/exercise_entry'

class BirlExerciseEntry extends Model {
  static schema = BirlExerciseEntrySchema;
  static modelName = 'BirlExerciseEntry';

  // Fill-in your attribute overrides
  static attributesDefinitions() {
    return {};
  }
}

export default BirlExerciseEntry.define();
